/**
 * Press Slider JavaScript
 * Pure CSS animation-based infinite slider
 */
document.addEventListener('DOMContentLoaded', function() {
  const pressSliders = document.querySelectorAll('.press-slider__carousel');
  
  pressSliders.forEach(slider => {
    initPressSlider(slider);
  });
});

function initPressSlider(slider) {
  const slidesContainer = slider.querySelector('.press-slider__slides-container');
  const slides = slider.querySelectorAll('.press-slider__slide');
  
  if (!slidesContainer || slides.length === 0) return;
  
  // Calculate animation duration based on number of slides
  const slideCount = slides.length / 2; // Divide by 2 because we duplicate slides
  const baseDuration = slideCount * 4; // 4 seconds per slide for smoother movement
  
  // Adjust duration for mobile devices
  const isMobile = window.innerWidth <= 767;
  const animationDuration = isMobile ? baseDuration * 0.3 : baseDuration;
  
  // Set CSS custom property for animation duration
  slider.style.setProperty('--slide-duration', `${animationDuration}s`);
  
  // Add hover pause functionality with smooth transitions
  slidesContainer.addEventListener('mouseenter', () => {
    slidesContainer.style.animationPlayState = 'paused';
  });
  
  slidesContainer.addEventListener('mouseleave', () => {
    slidesContainer.style.animationPlayState = 'running';
  });
  
  // Add intersection observer for performance optimization
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        slidesContainer.style.animationPlayState = 'running';
      } else {
        slidesContainer.style.animationPlayState = 'paused';
      }
    });
  }, {
    threshold: 0.1
  });
  
  observer.observe(slider);
  
  // Optimize performance - only animate first set of slides
  const firstSetSlides = Array.from(slides).slice(0, slideCount);
  firstSetSlides.forEach((slide, index) => {
    slide.style.opacity = '0';
    slide.style.transform = 'translateY(20px)';
    
    setTimeout(() => {
      slide.style.transition = 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
      slide.style.opacity = '1';
      slide.style.transform = 'translateY(0)';
    }, index * 50);
  });
  
  // Duplicate slides should be visible immediately (no animation)
  const duplicateSlides = Array.from(slides).slice(slideCount);
  duplicateSlides.forEach(slide => {
    slide.style.opacity = '1';
    slide.style.transform = 'translateY(0)';
  });
  
  // Add enhanced hover effects to individual slides
  slides.forEach(slide => {
    const slideInner = slide.querySelector('.press-slider__slide-inner');
    
    if (slideInner) {
      slideInner.addEventListener('mouseenter', () => {
        slideInner.style.transform = 'translateY(-8px) scale(1.02)';
        slideInner.style.boxShadow = '0 15px 50px rgba(0, 0, 0, 0.2)';
        slideInner.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
      });
      
      slideInner.addEventListener('mouseleave', () => {
        slideInner.style.transform = 'translateY(0) scale(1)';
        slideInner.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
      });
    }
  });
  
  // Store reference for external access with enhanced controls
  slider.pressSliderInstance = {
    pause: () => {
      slidesContainer.style.animationPlayState = 'paused';
    },
    play: () => {
      slidesContainer.style.animationPlayState = 'running';
    },
    toggle: () => {
      const isPaused = slidesContainer.style.animationPlayState === 'paused';
      if (isPaused) {
        slider.pressSliderInstance.play();
      } else {
        slider.pressSliderInstance.pause();
      }
    }
  };
}

// Responsive behavior with debouncing
let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const pressSliders = document.querySelectorAll('.press-slider__carousel');
    
    pressSliders.forEach(slider => {
      const slidesContainer = slider.querySelector('.press-slider__slides-container');
      if (slidesContainer) {
        // Recalculate animation duration for new screen size
        const slides = slider.querySelectorAll('.press-slider__slide');
        const slideCount = slides.length / 2;
        const baseDuration = slideCount * 4;
        const isMobile = window.innerWidth <= 767;
        const animationDuration = isMobile ? baseDuration * 0.3 : baseDuration;
        
        // Update animation duration
        slider.style.setProperty('--slide-duration', `${animationDuration}s`);
        slidesContainer.style.animationPlayState = 'running';
      }
    });
  }, 150);
});

// Accessibility improvements
document.addEventListener('keydown', function(e) {
  const activeSlider = document.activeElement.closest('.press-slider');
  
  if (activeSlider) {
    const slider = activeSlider.querySelector('.press-slider__carousel');
    
    if (slider && slider.pressSliderInstance) {
      switch(e.key) {
        case ' ':
          e.preventDefault();
          slider.pressSliderInstance.toggle();
          break;
        case 'Escape':
          slider.pressSliderInstance.pause();
          break;
      }
    }
  }
});

// Reduced motion support
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const pressSliders = document.querySelectorAll('.press-slider__carousel');
  
  pressSliders.forEach(slider => {
    const slidesContainer = slider.querySelector('.press-slider__slides-container');
    if (slidesContainer) {
      slidesContainer.style.animation = 'none';
    }
  });
}